import { useEffect, useState, useMemo, memo } from 'react'
import {
  selectMenu,
  setOffsetTop,
  useAppDispatch,
  useAppSelector,
} from '@open-tender/cloud'
import { animateScroll as scroll } from 'react-scroll'
import styled from '@emotion/styled'
import { slugify } from '@open-tender/utils'
import CategoryNav from '../Category/CategoryNav'
import MenuCategory from './MenuCategory'
import MenuNav from './MenuNav'
import MenuGroupOrder from './MenuGroupOrder'
import { MenuSection } from './MenuTop'
import { sendCategoryEventInScrollableMenu } from 'utils/helpers'
import { useNestedMenu } from 'hooks/useNestedMenu'
import NestedMenu from './NestedMenu'
// import MenuTags from './MenuTags'

const MenuScrollableView = styled.div`
  display: flex;
  justify-content: center;
  width: 100%;
`

const MenuScrollableCategories = styled.div`
  flex: 1 1 auto;
  max-width: 100%;
`
let sendMenuViewTimeout: NodeJS.Timeout

const MenuScrollable = memo(({ menuSections }: { menuSections: MenuSection[] }) => {
  const dispatch = useAppDispatch()
  const { categories, offsetTop } = useAppSelector(selectMenu)
  const { groups, isNested } = useNestedMenu(categories)

  const other = useMemo(() => menuSections.map((i) => ({
    ...i,
    items: i.items?.slice(0, 8),
  })), [menuSections])

  const navItems = useMemo(() => [
    ...other.map((i) => i.name),
    ...categories.map((i) => i.name),
  ], [other, categories])

  const [activeSection, setActiveSection] = useState(() => slugify(navItems[0]))

  useEffect(() => {
    if (isNested) return
    clearTimeout(sendMenuViewTimeout)
    sendMenuViewTimeout = setTimeout(() => {
      sendCategoryEventInScrollableMenu(categories, menuSections, activeSection)
    }, 200)
    return () => clearTimeout(sendMenuViewTimeout)
  }, [activeSection, categories, menuSections, isNested])

  const navType: any = 'TOP'

  useEffect(() => {
    if (offsetTop) {
      scroll.scrollTo(offsetTop, {
        duration: 0,
        smooth: false,
        offset: 0,
      })
      dispatch(setOffsetTop(null))
    }
  }, [offsetTop, dispatch])

  if (isNested) {
    return (
      <MenuScrollableView>
        <MenuScrollableCategories>
          <NestedMenu
            groups={groups}
            otherSections={other}
            showParentNav
            beforeSections={<MenuGroupOrder />}
            contentId="content"
          />
        </MenuScrollableCategories>
      </MenuScrollableView>
    )
  }

  return (
    <MenuScrollableView>
      {navType === 'LEFT' && <MenuNav items={navItems} />}
      <MenuScrollableCategories>
        {navType === 'TOP' && (
          <CategoryNav
            items={navItems}
            categories={categories}
            setActiveSection={setActiveSection}
          />
        )}
        {/* <MenuTags /> */}
        <MenuGroupOrder />
        {other.map((section) => (
          <div
            key={section.name}
            id={slugify(section.name)}
            className="section"
          >
            <MenuCategory category={section} />
          </div>
        ))}
        <div id="content">
          {categories.map((category) => (
            <div
              key={category.id}
              id={slugify(category.name)}
              className="section"
            >
              <MenuCategory category={category} />
              {category.children.map((child) => (
                <MenuCategory key={child.id} category={child} isChild={true} />
              ))}
            </div>
          ))}
        </div>
      </MenuScrollableCategories>
    </MenuScrollableView>
  )
})

export default MenuScrollable
